module.exports = __webpack_public_path__ + "img/wt-family.7aee7d8b.jpg";